import { Icon } from 'front-commons/ds';
import styled from 'styled-components';

export const TrashIcon = styled(Icon)`
	color: #000;
`;
